"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const LogManager_1 = require("../../Log/LogManager");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const Chat_1 = require("../Chat");
const IChatRepository_1 = require("../IChatRepository");
const ChatMessage_1 = require("../ChatMessage");
class ChatIndexedDbRepository {
    constructor(isService = false, cmdHub, evtHub, cmas, db) {
        this._logger = LogManager_1.logManager.GetLogger("ChatIndexedDbRepository");
        this._isService = false;
        this._isService = isService;
        this._commandHub = cmdHub;
        this._evtHub = evtHub;
        this._chatMessageAttachmentService = cmas;
        this.db = db;
    }
    async InitAsync() {
    }
    async ClearAsync() {
        await this.db.chats.clear();
        await this.db.chatMessages.clear();
    }
    async ChatOfIdAsync(id) {
        return await this.LoadAsync(id);
    }
    async ChatOfChatMessageAsync(cm) {
        return await this.LoadAsync(cm.BelongToChatId);
    }
    async FindChatByTempIdAsync(tempId) {
        const foundChatDaos = await this.db.chats.where("tempId").equals(tempId).toArray();
        if (foundChatDaos.length === 0)
            return Chat_1.Chat.INVALID_CHAT;
        else {
            const loadedChat = this.chatFromChatDao(foundChatDaos[0]);
            return loadedChat;
        }
    }
    async ActiveChatsOfUserAsync(username, retrieveChatMessageCount) {
        const userParticipatedChats = [];
        await this.db.chats.each(chatDao => {
            const chat = this.chatFromChatDao(chatDao);
            if (!chat.Participants.has(username))
                return;
            userParticipatedChats.push(chat);
        });
        if (userParticipatedChats.length === 0)
            return [];
        else {
            if (!retrieveChatMessageCount)
                return userParticipatedChats;
            else {
                return await Promise.all(userParticipatedChats.map((c) => this.LoadWithSpecifiedChatMessageCountAsync(c.id, retrieveChatMessageCount)));
            }
        }
    }
    async SaveChatDaoAsync(incommingChatDao) {
        await this.db.chats.add(incommingChatDao);
    }
    async SaveAsync(chat) {
        const existChatDao = await this.db.chats.get(chat.id);
        if (!existChatDao) {
            //Insert case
            const incommingChatDao = this.chatDaoFromChat(chat);
            await this.db.transaction('rw', this.db.chats, this.db.chatMessages, this.db.chatMessageAttachments, async () => {
                const allPromise = [];
                allPromise.push(AddChatDaoAsync(this.db, incommingChatDao));
                for (const cm of chat.Messages) {
                    allPromise.push(...this.InternalSaveChatMessageAsync(cm));
                }
                await Promise.all(allPromise);
            });
        }
        else {
            //Update case
            const changeRecords = chat.changeRecords;
            if (!changeRecords)
                return;
            await this.db.transaction('rw', this.db.chats, this.db.chatMessages, this.db.chatMessageAttachments, async () => {
                //應該根據更動的ChangeRecord一一更新對應欄位
                const allPromise = [];
                for (const cr of changeRecords) {
                    this._logger.debug(`開始處理${cr.operation}.${cr.fieldName}`);
                    const fieldName = cr.fieldName;
                    const fieldValue = cr.value;
                    switch (fieldName) {
                        case Chat_1.Chat.PARTICIPANT_READ_COUNT_PROPERTY_NAME:
                            {
                                const participant = fieldValue.Item1;
                                const count = fieldValue.Item2;
                                const orgParticipantReadCounts = existChatDao.participantReadCounts;
                                const newParticipantReadCounts = orgParticipantReadCounts.set(participant, count);
                                const updateJsonObj = {};
                                updateJsonObj[fieldName] = newParticipantReadCounts;
                                allPromise.push(UpdateChatDto(this.db, existChatDao.id, updateJsonObj));
                                break;
                            }
                        case Chat_1.Chat.MESSAGES_PROPERTY_NAME:
                            const cm = fieldValue;
                            allPromise.push(...this.InternalSaveChatMessageAsync(cm));
                            break;
                        case Chat_1.Chat.TOTAL_CHATMESSAGE_COUNT_PROPERTY_NAME:
                            {
                                const updateJsonObj = {};
                                updateJsonObj[fieldName] = fieldValue;
                                allPromise.push(UpdateChatDto(this.db, existChatDao.id, updateJsonObj));
                                break;
                            }
                    }
                }
                //在IndexedDb的Transaction裡面用Promise要收集所有Promise一起等
                await Promise.all(allPromise);
            });
        }
        chat.clearChangeRecord();
        async function AddChatDaoAsync(db, incommingChatDao) {
            await db.chats.add(incommingChatDao);
        }
        async function UpdateChatDto(db, existChatDaoId, updateJsonObj) {
            await db.chats.update(existChatDaoId, updateJsonObj);
        }
    }
    async SaveChatMessageAsync(chatId, cm) {
        if (TypeScriptUtils_1.isNullOrEmpty(chatId)) {
            this._logger.error(`invalid {nameof$(Chat.Id)}=${chatId}`);
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        }
        const chatDao = this.db.chats.get(chatId);
        if (!chatDao) {
            this._logger.error(`No Chat=${chatId} is stored. Can't procceed.`);
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        }
        if (cm.BelongToChatId !== chatId) {
            this._logger.error(`Invalid ChatMessage.BelongToChatId=${cm.BelongToChatId}`);
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        }
        await this.db.transaction('rw', this.db.chatMessages, this.db.chatMessageAttachments, async () => {
            const allPromise = [];
            allPromise.push(...this.InternalSaveChatMessageAsync(cm));
            await Promise.all(allPromise);
        });
        return cm;
    }
    InternalSaveChatMessageAsync(cm) {
        const allPromise = [];
        const cmDao = this.chatMessageDaoFromChatMessage(cm);
        allPromise.push(putChatMessageDaoAsync(this.db, cmDao));
        allPromise.push(...this.SaveChatMessageAttachmentAsync(cm));
        return allPromise;
        async function putChatMessageDaoAsync(db, IChatMessageIndexedDbDao) {
            await db.chatMessages.put(cmDao);
        }
    }
    async SaveChatMessagesAsync(chatId, cms) {
        const savedCms = [];
        for (const cm of cms) {
            const resultCm = await this.SaveChatMessageAsync(chatId, cm);
            if (resultCm === ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE)
                continue;
            savedCms.push(resultCm);
        }
        return savedCms;
    }
    SaveChatMessageAttachmentAsync(cm) {
        const allPromise = [];
        allPromise.push(SaveThumbnailAsync(this._chatMessageAttachmentService), SaveAttachmentAsync(this._chatMessageAttachmentService));
        return allPromise;
        async function SaveThumbnailAsync(cmaService) {
            if (cm.IsContentTypeWithThumbnail() && await cm.HasThumbnailAsync()) {
                //有Thumbnail存Thumbnail
                const thumbnailName = cm.ThumbnailName();
                allPromise.push(cmaService.SaveAttachmentAsync(thumbnailName, await cm.GetThumbnailAsync()));
            }
        }
        async function SaveAttachmentAsync(cmaService) {
            if (cm.IsContentTypeWithAttachment() && await cm.HasAttachmentAsync()) {
                //有Attachment存Attachement
                const attachment = cm.AttachmentName();
                allPromise.push(cmaService.SaveAttachmentAsync(attachment, await cm.GetAttachmentAsync()));
            }
        }
    }
    async DeleteChatMessageDaoAttachment(cm) {
        if (cm.IsContentTypeWithThumbnail() && await cm.HasThumbnailAsync()) {
            //有Thumbnail存Thumbnail
            const thumbnailName = cm.ThumbnailName();
            await this._chatMessageAttachmentService.DeleteAttachmentAsync(thumbnailName);
        }
        if (cm.IsContentTypeWithAttachment() && (await cm.HasAttachmentAsync())) {
            //有Attachment存Attachement
            const attachment = cm.AttachmentName();
            await this._chatMessageAttachmentService.DeleteAttachmentAsync(attachment);
        }
    }
    async LoadAsync(id) {
        return await this.LoadWithSpecifiedChatMessageCountAsync(id, 0);
    }
    async LoadWithSpecifiedChatMessageCountAsync(id, retrieveChatMessageCount) {
        const [chatDao, chatMessageDaos] = await this.LoadChatDaoAsync(id, retrieveChatMessageCount);
        if (!chatDao)
            return Chat_1.Chat.INVALID_CHAT;
        const loadedChat = this.chatFromChatDao(chatDao, chatMessageDaos || []);
        this.AttachAttachmentSuppilerToChatMessages(loadedChat.Messages);
        return loadedChat;
    }
    async LoadBeforeAsync(id, beforeThisChatMessage, retrieveChatMessageCount) {
        if (!id)
            throw new IChatRepository_1.ChatRepositoryError('id should not be empty.');
        const cmDao = this.chatMessageDaoFromChatMessage(beforeThisChatMessage);
        const [chatDao, chatMessageDaos] = await this.LoadChatDaoAsync(id, retrieveChatMessageCount, cmDao, IChatRepository_1.Dir.Before);
        if (!chatDao)
            return Chat_1.Chat.INVALID_CHAT;
        const loadedChat = this.chatFromChatDao(chatDao, chatMessageDaos || []);
        this.AttachAttachmentSuppilerToChatMessages(loadedChat.Messages);
        return loadedChat;
    }
    async LoadAfterAsync(id, afterThisChatMessage, retrieveChatMessageCount) {
        if (!id)
            throw new IChatRepository_1.ChatRepositoryError('id should not be empty.');
        const cmDao = this.chatMessageDaoFromChatMessage(afterThisChatMessage);
        const [chatDao, chatMessageDaos] = await this.LoadChatDaoAsync(id, retrieveChatMessageCount, cmDao, IChatRepository_1.Dir.After);
        if (!chatDao)
            return Chat_1.Chat.INVALID_CHAT;
        const loadedChat = this.chatFromChatDao(chatDao, chatMessageDaos || []);
        this.AttachAttachmentSuppilerToChatMessages(loadedChat.Messages);
        return loadedChat;
    }
    async LoadChatMessageBeforeAsync(chatId, refOrdinal, retrieveChatMessageCount) {
        throw new Error("Not Implemented.");
    }
    async LoadChatMessageAsync(chatId, cmId) {
        const existCmDao = await this.db.chatMessages.get(cmId);
        if (existCmDao) {
            const cm = this.chatMessageFromChatMessageDao(existCmDao);
            this.AttachAttachmentSupplierToChatMessage(cm);
            return cm;
        }
        else
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
    }
    async LoadChatMessagesAsync(chatId, cmIds) {
        const chatMessages = [];
        for (const cmId of cmIds) {
            const cm = await this.LoadChatMessageAsync(chatId, cmId);
            chatMessages.push(cm);
        }
        return chatMessages;
    }
    async DeleteAsync(id) {
        if (TypeScriptUtils_1.isNullOrEmpty(id))
            throw new IChatRepository_1.ChatRepositoryError("Invalid id can't be deleted.");
        const existChat = await this.db.chats.get(id);
        if (!existChat) {
            this._logger.warn(`Delete a non exist Chat.Id=${id}`);
            return;
        }
        await this.db.transaction('rw', this.db.chats, this.db.chatMessages, this.db.chatMessageAttachments, async () => {
            const allPromise = [];
            //TODO: Delete related Attachment
            const allCmDaos = await this.db.chatMessages
                .where("belongToChatId")
                .equals(id)
                .toArray();
            allCmDaos.forEach((cmDao) => {
            });
            //Delete related ChatMessages
            const allCmDaoKeys = allCmDaos.map(cmDao => cmDao.id);
            allPromise.push(bulkDeleteChatMessageDaoAsync(this.db, allCmDaoKeys));
            //Delete Chat
            allPromise.push(deleteChatDaoAsync(this.db, id));
            await Promise.all(allPromise);
        });
        async function bulkDeleteChatMessageDaoAsync(db, allCmDaoKeys) {
            await db.chatMessages.bulkDelete(allCmDaoKeys);
        }
        async function deleteChatDaoAsync(db, id) {
            await db.chats.delete(id);
        }
    }
    async DoesChatMessageExists(cm) {
        const cmDao = await this.db.chatMessages.get(cm.id);
        return cmDao ? true : false;
    }
    async UpdateChatMessage(cm) {
        const needToUpdateCmDao = this.chatMessageDaoFromChatMessage(cm);
        const existCmDao = await this.db.chatMessages.get(needToUpdateCmDao.id);
        if (!existCmDao) {
            this._logger.warn(`No ChatMessage can be updated, ChatMessage=${cm.Text}`);
            return;
        }
        await this.db.chatMessages.put(needToUpdateCmDao);
    }
    GenerateId(participants) {
        return Chat_1.Chat.MakeTemp1on1ChatId(immutable_1.OrderedSet(participants));
    }
    async LoadChatDaoAsync(id, retrieveChatMessageCount, cmDao = undefined, dir = IChatRepository_1.Dir.None) {
        const loadedChatDao = await this.db.chats.get(id);
        if (!loadedChatDao)
            return [undefined, undefined];
        if (retrieveChatMessageCount === 0) {
            return [loadedChatDao, undefined];
        }
        else if (retrieveChatMessageCount === IChatRepository_1.ChatRepositoryConstant.LOAD_NO_LIMIT) {
            switch (dir) {
                case IChatRepository_1.Dir.None:
                    {
                        const now = new Date();
                        const chatMessageDaos = await this.db.chatMessages
                            .where("timestamp").belowOrEqual(now)
                            .and(cmDao => cmDao.belongToChatId === id)
                            .toArray();
                        return [loadedChatDao, chatMessageDaos];
                    }
                case IChatRepository_1.Dir.Before:
                    {
                        const beforeDate = cmDao && !TypeScriptUtils_1.isNullOrEmpty(cmDao.id) ? cmDao.timestamp : new Date();
                        const chatMessageDaos = await this.db.chatMessages
                            .where("timestamp").below(beforeDate)
                            .and(cmDao => cmDao.belongToChatId === id)
                            .toArray();
                        return [loadedChatDao, chatMessageDaos];
                    }
                case IChatRepository_1.Dir.After:
                    {
                        const afterDate = cmDao && !TypeScriptUtils_1.isNullOrEmpty(cmDao.id) ? cmDao.timestamp : new Date(0);
                        const chatMessageDaos = await this.db.chatMessages
                            .where("timestamp").above(afterDate)
                            .and(cmDao => cmDao.belongToChatId === id)
                            .toArray();
                        return [loadedChatDao, chatMessageDaos];
                    }
            }
        }
        else if (retrieveChatMessageCount > 0) {
            switch (dir) {
                case IChatRepository_1.Dir.None:
                    {
                        const now = new Date();
                        const chatMessageDaos = await this.db.chatMessages
                            .where("timestamp").belowOrEqual(now)
                            .and(cmDao => cmDao.belongToChatId === id)
                            //.where("belongToChatId").equals(id)
                            //.and(cmDao => cmDao.timestamp.getTime() < now.getTime())
                            .reverse()
                            .limit(retrieveChatMessageCount)
                            .toArray();
                        const ascendChatMessageDaos = chatMessageDaos.reverse();
                        return [loadedChatDao, ascendChatMessageDaos];
                    }
                case IChatRepository_1.Dir.Before:
                    {
                        const beforeDate = cmDao && !TypeScriptUtils_1.isNullOrEmpty(cmDao.id) ? cmDao.timestamp : new Date();
                        const chatMessageDaos = await this.db.chatMessages
                            .where("timestamp").below(beforeDate)
                            .and(cmDao => cmDao.belongToChatId === id)
                            .reverse()
                            .limit(retrieveChatMessageCount)
                            .toArray(); //拿出時間大小[3,2,1]
                        const ascendChatMessageDaos = chatMessageDaos.reverse();
                        return [loadedChatDao, ascendChatMessageDaos];
                    }
                case IChatRepository_1.Dir.After:
                    {
                        const afterDate = cmDao && !TypeScriptUtils_1.isNullOrEmpty(cmDao.id) ? cmDao.timestamp : new Date(0);
                        const chatMessageDaos = await this.db.chatMessages
                            .where("timestamp").above(afterDate)
                            .and(cmDao => cmDao.belongToChatId === id)
                            .limit(retrieveChatMessageCount)
                            .toArray();
                        return [loadedChatDao, chatMessageDaos];
                    }
            }
        }
        return [loadedChatDao, undefined];
    }
    AttachAttachmentSuppilerToChatMessages(cms) {
        for (const cm of cms) {
            this.AttachAttachmentSupplierToChatMessage(cm);
        }
    }
    AttachAttachmentSupplierToChatMessage(cm) {
        if (cm.IsContentTypeWithThumbnail()) {
            const thumbnailName = cm.ThumbnailName();
            cm.InjectThumbnailSupplier(async () => await this._chatMessageAttachmentService.HasAttachmentAsync(thumbnailName), async () => await this._chatMessageAttachmentService.LoadAttachmentAsync(thumbnailName));
        }
        if (cm.IsContentTypeWithAttachment()) {
            const attachmentName = cm.AttachmentName();
            cm.InjectAttachmentSupplier(async () => await this._chatMessageAttachmentService.HasAttachmentAsync(attachmentName), async () => await this._chatMessageAttachmentService.LoadAttachmentAsync(attachmentName));
        }
    }
    chatDaoFromChat(chat) {
        return {
            id: chat.id,
            tempId: chat.TempId,
            name: chat.Name,
            tags: chat.Tags,
            participants: this.toEs6Set(chat.Participants),
            participantReadCounts: this.toEs6Map(chat.ParticipantReadCounts),
            endedFor: this.toEs6Set(chat.EndedFor),
            createdFrom: new Date(chat.CreatedFrom),
            totalChatMessageCount: chat.TotalChatMessageCount,
        };
    }
    toEs6Set(orgSet) {
        return orgSet;
        // if (orgSet["_c"]) {
        //   return orgSet["_c"];
        // } else {
        //   return orgSet;
        // }
    }
    toEs6Map(orgMap) {
        return orgMap;
        // if (orgMap["_c"]) {
        //   return orgMap["_c"];
        // } else {
        //   return orgMap;
        // }
    }
    chatFromChatDao(chatDao, chatMessageDaos = []) {
        return new Chat_1.Chat(this._isService, this, this._commandHub, this._evtHub, this._chatMessageAttachmentService, {
            id: chatDao.id,
            TempId: chatDao.tempId,
            Name: chatDao.name,
            Tags: chatDao.tags,
            Participants: new Set(chatDao.participants),
            ParticipantReadCounts: new Map(chatDao.participantReadCounts),
            EndedFor: new Set(chatDao.endedFor),
            CreatedFrom: chatDao.createdFrom.getTime(),
            TotalChatMessageCount: chatDao.totalChatMessageCount,
            Messages: chatMessageDaos.map(cmDao => this.chatMessageFromChatMessageDao(cmDao))
        });
    }
    chatMessageDaoFromChatMessage(cm) {
        return {
            id: cm.id,
            timestamp: new Date(cm.TimeStamp),
            belongToChatId: cm.BelongToChatId,
            speaker: cm.Speaker,
            text: cm.Text,
            contentType: cm.ContentType,
        };
    }
    chatMessageFromChatMessageDao(cmDao) {
        return new ChatMessage_1.ChatMessage(this._isService, this._commandHub, this._evtHub, {
            id: cmDao.id,
            TimeStamp: cmDao.timestamp.getTime(),
            BelongToChatId: cmDao.belongToChatId,
            Speaker: cmDao.speaker,
            Text: cmDao.text,
            ContentType: cmDao.contentType
        });
    }
}
exports.ChatIndexedDbRepository = ChatIndexedDbRepository;
//# sourceMappingURL=ChatIndexedDbRepository.js.map